import React, { useState, useEffect, useContext } from "react";
import { useLocation, Link, useNavigate, Navigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { UserContext } from "../../../UserContext";
import register from "../../../assets/Images/register.png";
import logo from "../../../assets/Images/logo.png";
import "../login/login.css";
import { GetReferralName, OTPVerification, RegisterUser } from "../../../services/auth/Auth";
import toast from "react-hot-toast";

function Register() {
  const [referralName, setReferralName] = useState("");
  const [isOtpVerification, setIsOtpVerification] = useState(false);
  const [referralId, setReferralId] = useState("");
  const { toggleLoader } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const [currentUserId, setCurrentUserId] = useState("");

  useEffect(() => {
    localStorage.removeItem("userData");
    fetchReferral();
  }, [location]);

  const fetchReferral = async () => {
    // Parse the query parameter
    const queryParams = new URLSearchParams(location.search);
    const referralId = queryParams.get("r");

    if (referralId) {
      toggleLoader(true);
      try {
        const name = await GetReferralName(referralId);
        if (name) {
          setReferralName(name);
          setReferralId(referralId);
          toggleLoader(false);
        } else {
          toast.error("Invalid referral ID.");
        }
      } catch (error) {
        console.error("Failed to fetch referral name:", error);
        toast.error("Failed to fetch referral name.");
      } finally {
        toggleLoader(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    const { firstName, lastName, email, password, confirmPassword, mobile } = data;
  
    // Validate form fields
    if (!firstName || !lastName || !email || !password || !confirmPassword || !mobile) {
      toast.error("All fields are required!");
      return;
    }
  
    // Validate first name and last name length
    if (firstName.length < 3 || firstName.length > 20) {
      toast.error("First Name must be between 3 and 20 characters!");
      return;
    }
  
    if (lastName.length < 3 || lastName.length > 20) {
      toast.error("Last Name must be between 3 and 20 characters!");
      return;
    }
  
    // Validate mobile number length
    if (mobile.length !== 10) {
      toast.error("Mobile number must be exactly 10 digits!");
      return;
    }
  
    // Validate password length
    if (password.length < 5 || password.length > 20) {
      toast.error("Password must be between 5 and 20 characters!");
      return;
    }
  
    // Validate passwords match
    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }
  
    try {
      toggleLoader(true);
      const response = await RegisterUser(
        firstName + " " + lastName,
        email,
        referralId,
        password,
        mobile
      );
      const { userId } = response;
      setCurrentUserId(userId);
      setIsOtpVerification(true);
      toast.success(`Otp sent to ${email}`)
    } catch (error) {
      console.error("Registration failed:", error);
      toast.error(error.message);
    } finally {
      toggleLoader(false);
    }
  };

  const handleOTPVerification = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    const { otp } = data;
  
    // Validate OTP length
    if (otp.length !== 6) {
      toast.error("OTP must be 6 digits!");
      return;
    }
  
    try {
      toggleLoader(true);
      const response = await OTPVerification(currentUserId, otp);
      toast.success("OTP verification successful!");
      const { authtoken, user, wallet } = response;
      localStorage.setItem(
        "userData",
        JSON.stringify({ user, authtoken, wallet })
      );
      const lastPath = localStorage.getItem('lastPath') || '/'; // Retrieve the last path or default to home
      localStorage.removeItem('lastPath'); // Clean up the last path from storage
      navigate(lastPath); // Redirect to the last visited page or home
    } catch (error) {
      console.error("OTP verification failed:", error);
      toast.error(error.message);
    } finally {
      toggleLoader(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="auth-page">
      <div className="auth-header">
        <Link to="/" className="auth-logo">
          <img src={logo} alt="CGTHomes Logo" />
        </Link>
      </div>

      <div className="auth-container">
        <div className="auth-left">
          <div className="auth-image-wrapper">
            <img
              src={register}
              alt="Register Illustration"
              className="auth-image"
            />
          </div>
        </div>
        <div className="auth-right">
          <div className="auth-form-container">
            <div className="auth-form-header">
              <h2 className="auth-title">{isOtpVerification ? "Enter OTP to continue" : "Create a new account"}</h2>
              {
                !isOtpVerification && <p className="auth-subtitle">
              Already have account? <Link to={"/login"} className="auth-link">Login</Link>
            </p>
              }
            </div>
            {isOtpVerification ? (
              <form className="auth-form" onSubmit={handleOTPVerification}>
                <div className="form-group">
                  <label className="form-label">Enter OTP</label>
                  <input
                    type="Number"
                    name="otp"
                    placeholder="Enter 6-digit OTP"
                    className="form-control"
                    required
                  />
                </div>
                <button className="auth-btn auth-btn-primary" type="submit">
                  Verify OTP
                </button>
              </form>
            ) : (
              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group form-group-half">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Enter your name"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group form-group-half">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Enter your name"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your Email Address"
                    className="form-control"
                    required
                  />
                </div>
                {referralName && (
                  <div className="form-group">
                    <label className="form-label">Referral Name</label>
                    <input
                      type="text"
                      name="referralName"
                      placeholder="Referral Name"
                      className="form-control"
                      value={referralName}
                      disabled
                    />
                  </div>
                )}
                <div className="form-group password-field">
                  <label className="form-label">Create Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={!showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter your Password"
                      className="form-control"
                      required
                      autoComplete="off"
                    />
                    <button type="button" className="password-toggle" onClick={togglePasswordVisibility}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
                <div className="form-group password-field">
                  <label className="form-label">Confirm Password</label>
                  <div className="password-input-wrapper">
                    <input
                      type={!showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Enter Password Again"
                      className="form-control"
                      required
                      autoComplete="off"
                    />
                    <button type="button" className="password-toggle" onClick={toggleConfirmPasswordVisibility}>
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Mobile</label>
                  <input
                    type="Number"
                    name="mobile"
                    placeholder="Enter your Mobile Number"
                    className="form-control"
                    required
                  />
                </div>
                <button className="auth-btn auth-btn-primary" type="submit">
                  Register
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
